import { CommonModule } from '@angular/common';

import {

    AfterViewInit,

    Component,

    ElementRef,

    OnInit,

    ViewChild

} from '@angular/core';

import { FormsModule } from '@angular/forms';

import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from 'app/shared/api.service';

import { CartItem, CartService } from 'app/core/cart/cart.service';

declare var Splide: any;

declare var splide: any;

interface ResultMedia {

    url: string;

    type: 'image' | 'video';

    title: string;

}

interface ResultCategory {

    id: string;

    code?: string;

    title: string;

    description: string;

    icon: string;

    images: string[];

    items?: ResultMedia[];

}

@Component({

    selector: 'app-photobooth',

    standalone: true,

    imports: [

        CommonModule,

        FormsModule

    ],

    template: `

        <!-- Centered banner, matching the photobooth reference. -->

        <section class="booth-banner" aria-labelledby="booth-title">

            <div class="section-container booth-banner__container">

                <button type="button" class="booth-back" (click)="goBack()">

                    <span aria-hidden="true"><i class="fa fa-arrow-left"></i></span>

                    Kembali ke Home

                </button>

                <div class="booth-banner__content">

                    <h1 id="booth-title">{{ getFirstWords() || 'Visidea' }} <span class="text-emerald-400">{{ getLastWord() || 'Photobooth' }}</span>

                    </h1>

                    <p>{{ getDescription() }}</p>

                    <div class="booth-highlights">

                        <span><i class="fa fa-check-circle" aria-hidden="true"></i>High-Speed Instant Print</span>

                        <span><i class="fa fa-check-circle" aria-hidden="true"></i>Real-Time QR & Softfile</span>

                        <span><i class="fa fa-check-circle" aria-hidden="true"></i>Custom Frame & IT Support</span>

                        <span><i class="fa fa-magic" aria-hidden="true"></i>AI Background & AI Filter</span>

                    </div>

                </div>

            </div>

        </section>

        <!-- Product photo and details. -->

        <section class="booth-detail" aria-labelledby="product-title">

            <div class="section-container">

                <div class="booth-detail__grid">

                    <figure class="booth-product-photo">

                        <img [src]="getProductImage()"

                            [alt]="categoryData?.displayName || categoryData?.name || 'Photobooth Visidea'"

                            (error)="onImageError($event, getCategoryImage())">

                        <figcaption>{{ categoryData?.displayName || categoryData?.name || 'Photobooth Visidea' }}</figcaption>

                    </figure>

                    <div class="booth-product-info">

                        <span class="booth-category">PHOTOBOOTH VISIDEA</span>

                        <h2 id="product-title">{{ categoryData?.displayName || categoryData?.name || 'Photobooth' }}</h2>

                        <div class="booth-product-copy">

                            <h3>Detail produk</h3>

                            <p>{{ getDescription() }}</p>

                            <dl class="booth-specs">

                                <div>

                                    <dt>Dimensi unit</dt>

                                    <dd>&plusmn; 200 &times; 60 &times; 50 cm</dd>

                                </div>

                                <div>

                                    <dt>Area minimal</dt>

                                    <dd>2,5 &times; 2,5 m, termasuk properti dan antrean</dd>

                                </div>

                            </dl>

                        </div>

                        <section class="booth-more">

                            <h3>Persiapan & operasional</h3>

                            <dl class="booth-specs">

                                <div>

                                    <dt>Persiapan</dt>

                                    <dd>H-7 sampai H-1</dd>

                                </div>

                                <div>

                                    <dt>Setup</dt>

                                    <dd>2&ndash;3 jam sebelum event</dd>

                                </div>

                                <div>

                                    <dt>Operasional</dt>

                                    <dd>Sesuai durasi event</dd>

                                </div>

                                <div>

                                    <dt>Dismantle</dt>

                                    <dd>1&ndash;2 jam setelah event</dd>

                                </div>

                            </dl>

                            <p>Cocok untuk wedding, birthday party, corporate event, gathering, exhibition, festival, dan brand

                                activation.</p>

                        </section>

                        <section class="booth-more">

                            <h3>Detail layanan printer</h3>

                            <dl class="booth-specs">

                                <div>

                                    <dt>Printer</dt>

                                    <dd>DNP / sesuai paket pilihan</dd>

                                </div>

                                <div>

                                    <dt>Ukuran cetak</dt>

                                    <dd>4R (10 &times; 15 cm) atau Mini Strip</dd>

                                </div>

                                <div>

                                    <dt>Instant Print</dt>

                                    <dd>Hasil foto dicetak langsung di lokasi dan bisa dibawa pulang.</dd>

                                </div>

                                <div>

                                    <dt>Fast Output</dt>

                                    <dd>Proses cetak cepat untuk mendukung kelancaran sesi foto tamu.</dd>

                                </div>

                            </dl>

                        </section>

                        <section class="booth-more">

                            <h3>Fitur AI Photobooth</h3>

                            <dl class="booth-specs">

                                <div>

                                    <dt>AI Background & Filter</dt>

                                    <dd>Ganti latar dan eksplorasi gaya visual agar foto sesuai konsep acara.</dd>

                                </div>

                                <div>

                                    <dt>AI Frame</dt>

                                    <dd>Rekomendasi frame untuk melengkapi tampilan foto.</dd>

                                </div>

                                <div>

                                    <dt>AI-Enhanced</dt>

                                    <dd>Peningkatan hasil foto agar tampil lebih optimal.</dd>

                                </div>

                                <div>

                                    <dt>Smart Layout</dt>

                                    <dd>Rekomendasi tata letak untuk komposisi foto yang lebih rapi.</dd>

                                </div>

                                <div>

                                    <dt>Optimasi otomatis</dt>

                                    <dd>Penyesuaian kualitas foto secara otomatis untuk memaksimalkan hasil akhir.</dd>

                                </div>

                            </dl>

                        </section>

                    </div>

                </div>

            </div>

        </section>

        <!-- =========================================================

             PACKAGE

        ========================================================= -->

        <section class="package-section">

            <div class="section-container">

                <div class="package-section-header">

                    <span class="section-badge">PAKET PHOTOBOOTH</span>

                    <h2 class="package-title">Pilih Paket yang Sesuai dengan Kebutuhan Event Kamu</h2>

                    <p class="package-subtitle">Pilih durasi dan benefit yang paling sesuai dengan kebutuhan acara kamu.</p>

                </div>

                <div class="package-grid">

                    <article class="package-card" *ngFor="let item of getProducts(); let index = index; trackBy: trackByPackage">

                        <div class="package-body">

                            <div class="package-heading">

                                <span class="package-category">PHOTOBOOTH</span>

                                <h3>{{ item.name }}</h3>

                            </div>

                            <div class="package-pricing">

                                <span class="package-price-label">Harga paket</span>

                                <del *ngIf="getOriginalPrice(item) as originalPrice" class="package-original-price">
                                    Rp{{ originalPrice | number }}
                                </del>

                                <div class="package-price">Rp{{ item.price | number }}</div>

                            </div>

                            <ul class="package-benefits">

                                <li *ngFor="let benefit of getBenefits(item)">

                                    <span class="package-check"><i class="fa fa-check" aria-hidden="true"></i></span>

                                    <span>{{ benefit }}</span>

                                </li>

                            </ul>

                            <div class="package-actions">

                                <button type="button" class="package-button package-button--cart" (click)="addToCart(item)">

                                    <i class="fa fa-shopping-cart" aria-hidden="true"></i>

                                    <span>Keranjang</span>

                                </button>

                                <button type="button" class="package-button package-button--checkout" (click)="checkout(item)">

                                    <span>Checkout</span>

                                    <i class="fa fa-arrow-right" aria-hidden="true"></i>

                                </button>

                            </div>

                        </div>

                    </article>

                </div>

            </div>

        </section>

        <!-- =========================================================

             HASIL PHOTOBOOTH

        ========================================================= -->

        <section class="gallery-section">

            <div class="section-container gallery-container">

                <div class="gallery-shell">

                    <!-- =====================================================

                         HEADING

                    ====================================================== -->

                    <div class="gallery-heading">

                        <div class="gallery-heading__content">

                            <h2>

                                Hasil

                                {{ categoryData?.displayName || categoryData?.name || 'Photobooth' }}

                            </h2>

                            <p>

                                Lihat berbagai hasil foto dari event yang menggunakan

                                layanan photobooth Visidea Studio.

                            </p>

                        </div>

                    </div>

                    <!-- =====================================================

                         CATEGORIZED PHOTOBOOTH

                    ====================================================== -->

                    <ng-container

                        *ngIf="isCategorizedPhotobooth; else standardGallery"

                    >

                        <!-- CATEGORY BUTTON -->

                        <nav

                            *ngIf="resultCategories.length > 0"

                            class="gallery-categories"

                            aria-label="Kategori hasil foto photobooth"

                        >

                            <button

                                *ngFor="let result of resultCategories"

                                type="button"

                                class="gallery-category"

                                [class.gallery-category--active]="activeResultCategory === result.id"

                                [attr.data-category]="result.code || result.id"

                                [attr.aria-pressed]="activeResultCategory === result.id"

                                (click)="selectResultCategory(result.id)"

                            >

                                <i

                                    class="fa {{ result.icon }}"

                                    aria-hidden="true"

                                ></i>

                                <span>

                                    {{ result.title }}

                                </span>

                            </button>

                        </nav>

                        <!-- =================================================

                             ACTIVE RESULT

                        ================================================== -->

                        <article

                            *ngIf="activeResult as result"

                            class="gallery-result"

                            [attr.data-category]="result.code || result.id"

                            aria-live="polite"

                        >

                            <div

                                class="splide gallery-results"

                                #splideElement

                                [attr.aria-label]="'Slide hasil photobooth ' + result.title"

                            >

                                <div class="splide__track">

                                    <ul class="splide__list">

                                        <!-- =================================

                                             NEW ITEMS

                                        ================================== -->

                                        <ng-container

                                            *ngIf="result.items?.length; else legacyPhotoSlides"

                                        >

                                            <li

                                                *ngFor="let item of getLoopSlides(result.items); let i = index; trackBy: trackBySlideIndex"

                                                class="splide__slide"

                                                [attr.aria-hidden]="result.items && result.items.length < 3 && i >= result.items.length ? 'true' : null"

                                            >

                                                <div class="gallery-result__item">

                                                    <div

                                                        class="gallery-result__photo"

                                                        [attr.data-layout]="result.code || result.id"

                                                    >

                                                        <!-- IMAGE -->

                                                        <img

                                                            *ngIf="item.type === 'image'"

                                                            [src]="item.url"

                                                            [alt]="item.title"

                                                            loading="eager"

                                                        />

                                                        <!-- VIDEO -->

                                                        <video

                                                            *ngIf="item.type === 'video'"

                                                            [src]="item.url"

                                                            [attr.aria-label]="item.title"

                                                            controls

                                                            preload="metadata"

                                                            playsinline

                                                        ></video>

                                                    </div>

                                                </div>

                                            </li>

                                        </ng-container>

                                        <!-- =================================

                                             LEGACY PHOTO

                                        ================================== -->

                                        <ng-template #legacyPhotoSlides>

                                            <li

                                                *ngFor="let photo of getLoopSlides(result.images); let i = index; trackBy: trackBySlideIndex"

                                                class="splide__slide"

                                                [attr.aria-hidden]="result.images.length < 3 && i >= result.images.length ? 'true' : null"

                                            >

                                                <div

                                                    class="gallery-result__photo"

                                                    [attr.data-layout]="result.id"

                                                >

                                                    <img

                                                        [src]="photo"

                                                        [alt]="'Contoh hasil foto ' + result.title + ' ' + (i + 1)"

                                                        loading="eager"

                                                    />

                                                </div>

                                            </li>

                                        </ng-template>

                                    </ul>

                                </div>

                            </div>

                        </article>

                        <!-- =================================================

                             EMPTY

                        ================================================== -->

                        <div

                            *ngIf="resultCategories.length === 0"

                            class="gallery-empty"

                        >

                            <i

                                class="fa fa-picture-o"

                                aria-hidden="true"

                            ></i>

                            <span>

                                Belum ada foto tersedia

                            </span>

                        </div>

                    </ng-container>

                    <!-- =====================================================

                         STANDARD GALLERY

                    ====================================================== -->

                    <ng-template #standardGallery>

                        <div

                            *ngIf="photoSamples.length > 0"

                            class="splide standard-gallery"

                            #splideElement

                        >

                            <div class="splide__track">

                                <ul class="splide__list">

                                    <li

                                        class="splide__slide"

                                        *ngFor="let photo of getLoopSlides(photoSamples); let i = index; trackBy: trackBySlideIndex"

                                        [attr.aria-hidden]="photoSamples.length < 3 && i >= photoSamples.length ? 'true' : null"

                                    >

                                        <div class="gallery-card">

                                            <img

                                                [src]="photo.contents[0]?.url"

                                                [alt]="photo.title"

                                        loading="eager"

                                            />

                                        </div>

                                    </li>

                                </ul>

                            </div>

                        </div>

                        <!-- STANDARD EMPTY -->

                        <div

                            *ngIf="photoSamples.length === 0"

                            class="gallery-empty"

                        >

                            <i

                                class="fa fa-picture-o"

                                aria-hidden="true"

                            ></i>

                            <span>

                                Belum ada foto tersedia

                            </span>

                        </div>

                    </ng-template>

                </div>

            </div>

        </section>

    `,

    styleUrls: ['./photobooth.component.scss']

})

export class PhotoboothComponent implements OnInit, AfterViewInit {

    @ViewChild('splideElement')

    splideElement!: ElementRef;

    categorySlug: string | null = null;

    categoryId: number | null = null;

    categoryData: any = null;

    photoSamples: any[] = [];

    private readonly vintageLandscapePhoto =

        '/assets/visidea/photobooth-results/vintage/landscape/rafi-graduation.jpg';

    readonly poppyResults: ResultCategory[] = [

        {

            id: 'landscape',

            title: '4R Landscape',

            description: 'Foto ukuran 4R horizontal, cocok untuk foto grup.',

            icon: 'fa-picture-o',

            images: [

                '/assets/visidea/photobooth-results/landscape/sample-01.png',

                '/assets/visidea/photobooth-results/landscape/sample-03.png'

            ]

        },

        {

            id: 'portrait',

            title: '4R Portrait',

            description: 'Foto ukuran 4R vertikal, pas untuk individu atau pasangan.',

            icon: 'fa-mobile',

            images: [

                '/assets/visidea/photobooth-results/portrait/sample-01.png',

                '/assets/visidea/photobooth-results/portrait/sample-03.png'

            ]

        },

        {

            id: 'koran',

            title: 'Koran',

            description: 'Desain foto bergaya koran dengan momen dan cerita spesial.',

            icon: 'fa-newspaper-o',

            images: [

                '/assets/visidea/photobooth-results/koran/sample-01.png',

                '/assets/visidea/photobooth-results/koran/sample-02.png'

            ]

        },

        {

            id: 'strip-3',

            title: 'Strip 3',

            description: 'Tiga foto dalam satu strip vertikal untuk berbagai ekspresi.',

            icon: 'fa-columns',

            images: [

                '/assets/visidea/photobooth-results/strip-3/sample-01.png'

            ]

        }

    ];

    resultCategories: ResultCategory[] = this.poppyResults;

    hasAdminResults = false;

    activeResultCategory = 'landscape';

    get activeResult() {

        return this.resultCategories.find(result => result.id === this.activeResultCategory);

    }

    get isPoppyPhotobooth(): boolean {

        const category = (

            this.categorySlug ||

            this.categoryData?.slug ||

            this.categoryData?.name ||

            ''

        ).toLowerCase();

        return category.includes('poppy') || category.includes('popy');

    }

    get isVintagePhotobooth(): boolean {

        const category = (

            this.categorySlug || this.categoryData?.slug || this.categoryData?.name || ''

        ).toLowerCase();

        return category.includes('vintage');

    }

    get isCategorizedPhotobooth(): boolean {

        const category = (

            this.categorySlug || this.categoryData?.slug || this.categoryData?.name || ''

        ).toLowerCase();

        return this.hasAdminResults || this.isPoppyPhotobooth || this.isVintagePhotobooth ||

            category.includes('hypee') || category.includes('hyppe');

    }

    selectResultCategory(id: string): void {

        if (this.activeResultCategory === id) {

            return;

        }

        this.splide?.destroy();

        this.splide = null;

        this.activeResultCategory = id;

        setTimeout(() => this.initializeSplide());

    }

    private applyContentPlacements(product: any): void {

        const placements = product?.content_placements;

        if (!Array.isArray(placements) || placements.length === 0) {

            return;

        }

        const categories = new Map<string, ResultCategory>();

        for (const placement of placements) {

            if (placement.is_active === false || placement.is_active === 0 || placement.is_active === '0' ||

                placement.non_themed_product_id !== product.id) {

                continue;

            }

            const category = placement.category;

            const categoryId = category?.id || placement.content_category_id;

            if (!categoryId || category?.is_active === false) {

                continue;

            }

            let result = categories.get(categoryId);

            if (!result) {

                const rawCode = String(category?.code || category?.name || '').trim().toLowerCase();

                const code = /^strip[\s\_-]\*3$/.test(rawCode) ? 'strip-3' : rawCode;

                result = {

                    id: categoryId,

                    code,

                    title: category?.name || placement.title || 'Lainnya',

                    description: category?.description || '',

                    icon: this.poppyResults.find(item => item.id === code)?.icon ||

                        (code.includes('strip') ? 'fa-columns' : 'fa-picture-o'),

                    images: [],

                    items: []

                };

                categories.set(categoryId, result);

            }

            for (const content of placement.contents || []) {

                if (!content?.url) {

                    continue;

                }

                const isVideo = String(content.mime_type || '').startsWith('video/') ||

                    String(content.collection || '').includes('/videos');

                result.images.push(content.url);

                result.items!.push({

                    url: content.url,

                    type: isVideo ? 'video' : 'image',

                    title: placement.title || result.title

                });

            }

        }

        const availableResults = Array.from(categories.values()).filter(result => result.items!.length > 0);

        if (availableResults.length === 0) {
            return;
        }

        this.splide?.destroy();

        this.splide = null;

        this.hasAdminResults = true;

        this.resultCategories = availableResults;

        this.activeResultCategory = this.resultCategories[0]?.id || '';

        setTimeout(() => this.initializeSplide());

    }

    splide: any = null;

    private splideInitVersion = 0;

    private readonly singleSlideLoops = new WeakMap<object, unknown[]>();

    isLoading: boolean = true;

    selectedPackageIndex = 0;

    getSelectedProduct(): any {

        const products = this.getProducts();

        return products[this.selectedPackageIndex] || products[0];

    }

    /**
     * Duplicate slides when there are only 1 or 2 items so that
     * Splide's loop mode always has enough content to fill the
     * viewport without any blank gaps from start to end.
     *
     * - 1 slide  → duplicated to 4 copies
     * - 2 slides → duplicated to 4 copies
     * - 3+ slides → returned as-is
     *
     * Video-only single slides are skipped (no looping needed).
     */
    getLoopSlides<T>(slides: T[] | undefined): T[] {
        if (!slides || slides.length === 0) {
            return [];
        }

        // Single video slide – no duplication needed.
        if (slides.length === 1 && (slides[0] as ResultMedia)?.type === 'video') {
            return slides;
        }

        // 3 or more slides – enough content for seamless looping.
        if (slides.length >= 3) {
            return slides;
        }

        // 1 or 2 slides – duplicate to fill the viewport.
        let loopSlides = this.singleSlideLoops.get(slides) as T[] | undefined;
        const firstMatch = loopSlides && loopSlides.length > 0 && loopSlides[0] === slides[0];
        if (!loopSlides || !firstMatch) {
            // Repeat the original array until we have at least 4 items.
            const minSlides = 4;
            const repeatCount = Math.ceil(minSlides / slides.length);
            loopSlides = [];
            for (let r = 0; r < repeatCount; r++) {
                for (const slide of slides) {
                    loopSlides.push(slide);
                }
            }
            this.singleSlideLoops.set(slides, loopSlides);
        }

        return loopSlides;
    }

    trackBySlideIndex(index: number): number {
        return index;
    }

    constructor(

        private apiService: ApiService,

        private router: Router,

        private route: ActivatedRoute,

        private cartService: CartService

    ) { }

    ngOnInit(): void {

        this.route.params.subscribe(params => {

            this.splide?.destroy();

            this.splide = null;

            this.selectedPackageIndex = 0;

            this.categorySlug =

                params['slug'] || null;

            this.categoryData = null;

            this.hasAdminResults = false;

            this.photoSamples = [];

            this.resultCategories = this.isPoppyPhotobooth ? this.poppyResults : [];

            this.activeResultCategory = 'landscape';

            this.loadPhotoboothCategory(

                this.categorySlug

            );

        });

    }

    ngAfterViewInit(): void {

        // Galeri Poppy memakai foto lokal dan bisa tampil sebelum respons API datang.

        setTimeout(() => this.initializeSplide());

    }

    /* =========================================================

       BACK

    ========================================================= */

    goBack(): void {

        this.router.navigate(['/']);

    }

    /* =========================================================

       SPLIDE

    ========================================================= */

    async initializeSplide(): Promise<void> {

        const initVersion = ++this.splideInitVersion;

        const isCategorized = this.isCategorizedPhotobooth;

        const categoryPhotoCount = this.activeResult?.items?.length
            ? this.getLoopSlides(this.activeResult.items).length
            : this.getLoopSlides(this.activeResult?.images).length;

        const standardPhotoCount =
            this.getLoopSlides(this.photoSamples).length;

        const currentPhotoCount =
            isCategorized
                ? categoryPhotoCount
                : standardPhotoCount;

        const canSlide =
            currentPhotoCount > 1;

        const hasVideo =
            this.activeResult?.items?.some(
                item => item.type === 'video'
            ) || false;

        if (
            !this.splideElement ||
            (
                isCategorized
                    ? categoryPhotoCount === 0
                    : standardPhotoCount === 0
            )
        ) {
            return;
        }

        if (this.splide) {
            this.splide.destroy();
            this.splide = null;
        }

        const galleryElement = this.splideElement.nativeElement as HTMLElement;
        const activeCategory = this.activeResultCategory;

        // autoWidth needs the real image widths before Splide creates its loop clones.
        if (isCategorized) {
            const images = Array.from(
                galleryElement.querySelectorAll<HTMLImageElement>('.splide__list > .splide__slide img')
            );
            await Promise.all(images.map(image => image.decode().catch(() => undefined)));

            if (
                !galleryElement.isConnected ||
                galleryElement !== this.splideElement?.nativeElement ||
                activeCategory !== this.activeResultCategory ||
                initVersion !== this.splideInitVersion
            ) {
                return;
            }
        }

        const autoScrollExtension =
            typeof window !== 'undefined'
                ? (window as any).splide?.Extensions?.AutoScroll
                : null;

        /*
         * Semua gallery berkategori:
         * - Poppy
         * - Vintage
         * - Hypee / Hyppe
         * - kategori dari admin / content_placements
         * - Landscape
         * - Portrait
         * - Koran
         * - Strip 2
         * - Strip 3
         * - AI
         *
         * memakai autoWidth agar lebar slide mengikuti media.
         * Ini menghilangkan ruang kosong besar antar foto.
         */
        const options: any = {
            type:
                canSlide
                    ? 'loop'
                    : 'slide',

            drag:
                hasVideo
                    ? false
                    : canSlide
                        ? true
                        : false,

            focus:
                isCategorized
                    ? 0
                    : 'center',

            gap: '6px',

            pagination: false,

            arrows:
                hasVideo && canSlide,

            autoplay:
                canSlide &&
                !autoScrollExtension &&
                !hasVideo,

            interval: 3500,

            speed: 700,

            pauseOnHover: true,

            pauseOnFocus: true,

            autoScroll: {
                speed:
                    isCategorized
                        ? 0.45
                        : 1,

                pauseOnHover: true,

                pauseOnFocus: true,
            },

            breakpoints: {
                1180: {
                    gap: '6px',
                },

                900: {
                    gap: '5px',
                },

                640: {
                    gap: '4px',
                },
            },
        };

        if (isCategorized) {

            /*
             * PENTING:
             * Jangan gunakan perPage pada gallery kategori.
             * autoWidth membuat tiap slide mengikuti ukuran
             * foto/video sehingga tidak ada area putih besar.
             */
            options.autoWidth = true;

            if (canSlide) {
                const slideWidths = Array.from(
                    galleryElement.querySelectorAll<HTMLElement>('.splide__list > .splide__slide')
                ).map(slide => slide.getBoundingClientRect().width).filter(width => width > 0);
                const trackWidth = galleryElement.querySelector<HTMLElement>('.splide__track')?.clientWidth || 0;
                const narrowestSlide = Math.min(...slideWidths);

                // Fill both sides of the viewport, including categories with only two narrow photos.
                options.clones = slideWidths.length
                    ? Math.min(24, Math.ceil(trackWidth / narrowestSlide) + 2)
                    : 4;
            }

        } else {

            /*
             * Gallery standar tetap menggunakan layout perPage
             * supaya type photobooth lama yang belum berkategori
             * tetap stabil dan responsif.
             */
            options.perPage = Math.min(4, Math.max(1, currentPhotoCount - 1));

            options.breakpoints = {
                1180: {
                    perPage: Math.min(3, options.perPage),
                    gap: '6px',
                },

                900: {
                    perPage: Math.min(2, options.perPage),
                    gap: '5px',
                },

                640: {
                    perPage: 1,
                    gap: '4px',
                },
            };
        }

        this.splide = new Splide(
            this.splideElement.nativeElement,
            options
        );

        if (
            autoScrollExtension &&
            canSlide &&
            !hasVideo
        ) {

            this.splide.mount(
                (window as any).splide.Extensions
            );

        } else {

            this.splide.mount();

        }

    }

    private async updateFormatCategories(): Promise<void> {

        if (this.hasAdminResults || !this.isCategorizedPhotobooth || this.isPoppyPhotobooth) {

            return;

        }

        const currentSlug = this.categorySlug;

        const isVintage = this.isVintagePhotobooth;

        const vintageStripIds = new Set(['150', '151', '152', '154']);

        // Sampel Arcade dan ilustrasi AI belum diberi jenis efek oleh API foto.

        const vintageAiIds = new Set(['144', '149']);

        const categorized = await Promise.all(this.photoSamples.map(async photo => {

            const url = photo.contents?.[0]?.url;

            if (!url) {

                return null;

            }

            // Product images now have UUIDs; the legacy format number remains in the storage path.
            const photoId = String(photo.id || '');
            const id = /^\d+$/.test(photoId)
                ? photoId
                : url.match(/\/storage\/(\d+)\//)?.[1] || '';

            const label = [photo.category, photo.type, photo.title, url].filter(Boolean).join(' ').toLowerCase();

            let format: string;

            if (isVintage && (vintageAiIds.has(id) || /guest_38696|guest_433755|\bai\b|ai[-\_ ]?(filter|photo|foto)/.test(label))) {

                format = 'ai';

            } else if (isVintage && vintageStripIds.has(id) || /strip[-\_ ]?2/.test(label)) {

                format = 'strip-2';

            } else if (/strip[-\_ ]?3/.test(label)) {

                format = 'strip-3';

            } else if (/koran|newspaper/.test(label)) {

                format = 'koran';

            } else if (isVintage && id === '155' || !isVintage && Number(id) >= 157 && Number(id) <= 171) {

                format = 'landscape';

            } else if (isVintage && Number(id) >= 144 && Number(id) <= 156) {

                format = 'portrait';

            } else {

                format = await new Promise<string>(resolve => {

                    const image = new Image();

                    image.onload = () => resolve(image.naturalWidth >= image.naturalHeight ? 'landscape' : 'portrait');

                    image.onerror = () => resolve(isVintage ? 'portrait' : 'landscape');

                    image.src = url;

                });

            }

            return { url, format };

        }));

        if (currentSlug !== this.categorySlug) {

            return;

        }

        const definitions = [

            ...this.poppyResults.filter(result => result.id !== 'strip-3'),

            {

                id: 'strip-2',

                title: 'Strip 2',

                description: 'Dua foto dalam satu cetakan vertikal.',

                icon: 'fa-columns',

                images: [] as string[]

            },

            this.poppyResults.find(result => result.id === 'strip-3')!,

            ...(isVintage ? [{

                id: 'ai',

                title: 'Foto AI',

                description: 'Hasil foto dengan latar atau efek ilustrasi AI.',

                icon: 'fa-magic',

                images: [] as string[]

            }] : [])

        ];

        this.resultCategories = definitions.map(result => {

            const images = categorized

                .filter((photo): photo is { url: string; format: string } => !!photo && photo.format === result.id)

                .map(photo => photo.url);

            if (isVintage && result.id === 'landscape' &&

                !images.some(url => /RAFILAZHILALHASANUDIN_merge_photo_1/i.test(url))) {

                images.push(this.vintageLandscapePhoto);

            }

            return { ...result, images };

        }).filter(result => result.images.length > 0);

        this.activeResultCategory = isVintage && this.resultCategories.some(result => result.id === 'portrait')

            ? 'portrait'

            : this.resultCategories[0]?.id || 'landscape';

    }

    /* =========================================================

       LOAD CATEGORY

    ========================================================= */

    async loadPhotoboothCategory(

        slug: string | null

    ): Promise<void> {

        this.isLoading = true;

        try {

            const apiEndpoint =

                '/api/v1/front/public/non-themed-products/list';

            let response =

                await this.apiService.get(

                    apiEndpoint,

                    false

                );

            if (

                !response ||

                !response.success ||

                !response.data?.list

            ) {

                try {

                    const devRes =

                        await fetch(

                            `https\://dev.api.visideastudio.com${apiEndpoint}`

                        );

                    if (devRes.ok) {

                        response =

                            await devRes.json();

                    }

                } catch (error) {

                    console.error(

                        'Dev API fallback error:',

                        error

                    );

                }

            }

            let list: any[] = [];

            if (

                response?.data?.list &&

                Array.isArray(

                    response.data.list

                )

            ) {

                list =

                    response.data.list;

            } else if (

                response?.data &&

                Array.isArray(

                    response.data

                )

            ) {

                list =

                    response.data;

            }

            if (list.length > 0) {

                let foundProduct: any = null;

                const cleanSlug =

                    (

                        slug ||

                        'vintage'

                    )

                    .toLowerCase()

                    .replace(

                        '-photobooth',

                        ''

                    )

                    .replace(

                        'photobooth',

                        ''

                    )

                    .replace(

                        'hyppe',

                        'hypee'

                    )

                    .trim();

                if (cleanSlug) {

                    foundProduct =

                        list.find(

                            (item: any) => {

                                const itemName =

                                    (

                                        item.name ||

                                        ''

                                    )

                                    .toLowerCase();

                                const itemSlug =

                                    (

                                        item.slug ||

                                        ''

                                    )

                                    .toLowerCase();

                                return (

                                    itemName.includes(

                                        cleanSlug

                                    ) ||

                                    cleanSlug.includes(

                                        itemName

                                    ) ||

                                    itemSlug.includes(

                                        cleanSlug

                                    ) ||

                                    item.id === slug

                                );

                            }

                        );

                }

                if (!foundProduct) {

                    foundProduct =

                        list.find(

                            (item: any) =>

                                (

                                    item.product_category_name ||

                                    ''

                                )

                                .toLowerCase()

                                .includes(

                                    'photobooth'

                                )

                        ) || list[0];

                }

                if (foundProduct) {

                    this.categoryData =

                        foundProduct;

                    this.categoryId =

                        foundProduct.id;

                    this.categorySlug =

                        slug ||

                        foundProduct.name;

                    if (

                        this.categoryData.name &&

                        !this.categoryData.name

                            .toLowerCase()

                            .includes(

                                'photobooth'

                            )

                    ) {

                        const capitalized =

                            this.categoryData.name

                                .charAt(0)

                                .toUpperCase() +

                            this.categoryData.name

                                .slice(1);

                        this.categoryData.displayName =

                            `${capitalized} Photobooth`;

                    } else {

                        this.categoryData.displayName =

                            this.categoryData.name;

                    }

                    this.applyContentPlacements(foundProduct);

                    if (!this.hasAdminResults) {

                        await this.getPhoto();

                    }

                    await this.loadPackages(foundProduct.id);

                } else if (slug) {

                    this.setFallbackCategory(

                        slug

                    );

                }

            } else if (slug) {

                this.setFallbackCategory(

                    slug

                );

            }

        } catch (error) {

            console.error(

                'Error loading photobooth category list from DB:',

                error

            );

            if (slug) {

                this.setFallbackCategory(

                    slug

                );

            }

        } finally {

            this.isLoading = false;

            if (this.isPoppyPhotobooth) {

                setTimeout(() => this.initializeSplide());

            } else if (this.isVintagePhotobooth && !this.hasAdminResults && this.resultCategories.length === 0) {

                const landscape = this.poppyResults.find(result => result.id === 'landscape')!;

                this.resultCategories = [{ ...landscape, images: [this.vintageLandscapePhoto] }];

                this.activeResultCategory = 'landscape';

                setTimeout(() => this.initializeSplide());

            }

        }

    }

    async loadPackages(productId: string): Promise<void> {

        try {

            const apiEndpoint = `/api/v1/front/public/non-themed-product-packages/list?paginate=true&search=&page=1&per_page=50&non_themed_product_id=${productId}&is_active=1`;

            let response = await this.apiService.get(apiEndpoint, false);

            if (!response || !response.success || !response.data?.list) {

                try {

                    const devRes = await fetch(`https\://dev.api.visideastudio.com${apiEndpoint}`);

                    if (devRes.ok) {

                        response = await devRes.json();

                    }

                } catch (error) {

                    console.error('Dev API fallback error for packages:', error);

                }

            }

            if (response?.data?.list && Array.isArray(response.data.list)) {

                if (!this.categoryData) {

                    this.categoryData = {};

                }

                this.categoryData.packages = response.data.list;

            }

        } catch (error) {

            console.error('Error fetching photobooth packages:', error);

        }

    }

    /* =========================================================

       FALLBACK CATEGORY

    ========================================================= */

    setFallbackCategory(

        slug: string

    ): void {

        const s =

            (

                slug ||

                ''

            ).toLowerCase();

        if (

            s.includes(

                'poppy'

            )

        ) {

            this.categoryData = {

                name: 'poppy',

                displayName:

                    'Poppy Photobooth',

                slug:

                    'poppy-photobooth',

                description:

                    'Photobooth berkonsep fun, dynamic dan interaktif dari Visidea Studio siap kasih pengalaman foto yang seru dan Stylish buat melengkapi setiap event spesial kamu',

                packages: [

                    {

                        id: '1',

                        name: 'Poppy Basic',

                        price: 1600000

                    },

                    {

                        id: '2',

                        name: 'Poppy Elite',

                        price: 2250000

                    }

                ]

            };

            return;

        }

        if (

            s.includes(

                'vintage'

            )

        ) {

            this.categoryData = {

                name:

                    'vintage',

                displayName:

                    'Vintage Photobooth',

                slug:

                    'vintage-photobooth',

                description:

                    'Photobooth bernuansa klasik nan elegan dari Visidea Studio bawa vibe nostalgia di setiap potret manis pas buat pesta pernikahan anniversary atau event vintage',

                packages: [

                    {

                        id: '1',

                        name: 'Vintage Basic',

                        price: 1600000

                    },

                    {

                        id: '2',

                        name: 'Vintage Elite',

                        price: 2250000

                    }

                ]

            };

            return;

        }

        this.categoryData = {

            name:

                'hypee',

            displayName:

                'Hyppe Photobooth',

            slug:

                'hyppe-photobooth',

            description:

                'Photobooth bergaya kasual yang ceria dari Visidea Studio siap bikin makin ramai berbagai acara seru kamu seperti pesta ulang tahun, festival, gathering, wisuda hingga momen spesial lainnya',

            packages: [

                {

                    id: '1',

                    name: 'Hypee Basic',

                    price: 1600000

                },

                {

                    id: '2',

                    name: 'Hypee Elite',

                    price: 2250000

                }

            ]

        };

    }

    async getCategoryBySlug(

        slug: string

    ): Promise<void> {

        await this.loadPhotoboothCategory(

            slug

        );

    }

    async getDataCategory(

        categoryId: any

    ): Promise<void> {

        try {

            const response =

                await this.apiService.get(

                    `/api/v1/front/public/non-themed-products/${categoryId}`,

                    false

                );

            if (response?.data) {

                this.categoryData =

                    response.data;

                this.applyContentPlacements(response.data);

                if (!this.hasAdminResults) {

                    await this.getPhoto();

                }

            }

        } catch (error) {

            console.error(

                'Error loading category details from DB:',

                error

            );

        }

    }

    /* =========================================================

       PHOTO

    ========================================================= */

    async getPhoto(): Promise<void> {

        try {

            if (

                this.categoryData?.images &&

                Array.isArray(

                    this.categoryData.images

                ) &&

                this.categoryData.images.length > 0

            ) {

                this.photoSamples =

                    this.categoryData.images.map(

                        (img: any) => ({

                            id: typeof img === 'string' ? null : img.id,

                            category: typeof img === 'string' ? null : img.category,

                            contents: [

                                {

                                    url:

                                        typeof img === 'string'

                                            ? img

                                            : (

                                                img.url ||

                                                img.image_url

                                            )

                                }

                            ],

                            title:

                                this.categoryData.displayName ||

                                this.categoryData.name

                        })

                    );

                await this.updateFormatCategories();

                setTimeout(

                    () => {

                        this.initializeSplide();

                    },

                    100

                );

                return;

            }

            const photoboothType =

                this.categoryData

                    ?.properties

                    ?.[0]

                    ?.code_category;

            if (!photoboothType) {

                return;

            }

            const apiUrl =

                `api/v1/public/service/photobooth/photo-samples?photobooth_type=${photoboothType}`;

            let response =

                await this.apiService

                    .getPhotobooth(

                        apiUrl

                    );

            if (

                !response ||

                !response.data

            ) {

                response =

                    await this.apiService.get(

                        '/' + apiUrl,

                        false

                    );

            }

            if (

                response?.data &&

                Array.isArray(

                    response.data

                )

            ) {

                this.photoSamples =

                    response.data;

                await this.updateFormatCategories();

                setTimeout(

                    () => {

                        this.initializeSplide();

                    },

                    100

                );

            }

        } catch (error) {

            console.error(

                'Error loading photobooth photos from DB:',

                error

            );

        }

    }

    /* =========================================================

       TEXT

    ========================================================= */

    getFirstWords(): string {

        const name =

            this.categoryData?.displayName ||

            this.categoryData?.name;

        if (!name) {

            return 'Visidea';

        }

        const words =

            name

                .trim()

                .split(' ');

        if (

            words.length <= 1

        ) {

            return words[0];

        }

        return words

            .slice(

                0,

                -1

            )

            .join(' ');

    }

    getLastWord(): string {

        const name =

            this.categoryData?.displayName ||

            this.categoryData?.name;

        if (!name) {

            return 'Photobooth';

        }

        const words =

            name

                .trim()

                .split(' ');

        return words.length > 1

            ? words[

                words.length - 1

            ]

            : '';

    }

    getDescription(): string {

        // Return description from API only, no static fallback

        return this.categoryData?.description || '';

    }

    /* =========================================================

       PACKAGE

    ========================================================= */

    getProducts(): any[] {

        if (

            this.categoryData?.products &&

            Array.isArray(

                this.categoryData.products

            ) &&

            this.categoryData.products.length > 0

        ) {

            return this.categoryData.products;

        }

        if (

            this.categoryData?.packages &&

            Array.isArray(

                this.categoryData.packages

            ) &&

            this.categoryData.packages.length > 0

        ) {

            return this.categoryData.packages.map(

                (

                    pkg: any,

                    index: number

                ) => {

                    const pkgName =

                        pkg.name ||

                        `Paket ${index + 1}`;

                    return {
                        ...pkg,

                        id:

                            pkg.id,

                        name:

                            pkg.name

                                ? (

                                    pkg.name

                                        .charAt(0)

                                        .toUpperCase() +

                                    pkg.name

                                        .slice(1)

                                )

                                : pkgName,

                        price:

                            (pkg.price !== undefined && pkg.price !== null) ? Number(pkg.price) : 0,

                        properties: {

                            benefit:

                                pkg.properties?.benefit ||

                                pkg.benefit ||

                                pkg.description ||

                                []

                        }

                    };

                }

            );

        }

        // Return empty array if no data from API

        return [];

    }

    getOriginalPrice(item: any): number | null {

        const originalPrice = Number(
            item?.regular_price ??
            item?.original_price ??
            item?.originalPrice
        );
        const currentPrice = Number(item?.price);

        return Number.isFinite(originalPrice) &&
            originalPrice > currentPrice &&
            currentPrice >= 0
            ? originalPrice
            : null;

    }

    private getDefaultPackages(): any[] {

        return [

            {

                name:

                    'Paket 1 (2 Jam)',

                price:

                    1600000,

                properties: {

                    benefit: [

                        'Unlimited print (2 jam)',

                        'Real-time softfile via QR',

                        'General backdrop',

                        '1 custom frame pilihan',

                        '1 crew IT support',

                        'Plastik frame cover',

                        '5 properti pilihan'

                    ]

                }

            },

            {

                name:

                    'Paket 2 (3 Jam)',

                price:

                    2000000,

                properties: {

                    benefit: [

                        'Unlimited print (3 jam)',

                        'Real-time softfile via QR',

                        'General backdrop',

                        '2 custom frame pilihan',

                        '1 crew IT support',

                        'Plastik frame cover',

                        '10 properti pilihan'

                    ]

                }

            },

            {

                name:

                    'Paket 3 (4 Jam)',

                price:

                    2250000,

                properties: {

                    benefit: [

                        'Unlimited print (4 jam)',

                        'Real-time softfile via QR',

                        'Sequin backdrop',

                        '3 custom frame pilihan',

                        '2 crew IT support',

                        'Premium frame cover',

                        'Voucher (by request)',

                        '15 properti pilihan',

                        'Special souvenir'

                    ]

                }

            }

        ];

    }

    getBenefits(

        item: any

    ): string[] {
        const rawDescription = item?.description;
        if (typeof rawDescription === 'string' && rawDescription.trim()) {
            return rawDescription
                .split(/\r?\n/)
                .map((benefit: string) => benefit.trim())
                .filter((benefit: string) => benefit.length > 0);
        }

        const benefits =

            item?.properties?.benefit ??

            item?.benefit ??

            item?.benefits ??

            item?.features;

        if (Array.isArray(benefits)) {

            return benefits

                .map((benefit: any) => this.formatBenefit(String(benefit).trim()))

                .filter((benefit: string) => benefit.length > 0);

        }

        if (typeof benefits !== 'string' || !benefits.trim()) {

            return [];

        }

        try {

            const parsed = JSON.parse(benefits);

            if (Array.isArray(parsed)) {

                return parsed

                    .map((benefit: any) => this.formatBenefit(String(benefit).trim()))

                    .filter((benefit: string) => benefit.length > 0);

            }

        } catch {

            return benefits

                .split(/\r?\n/)

                .map((benefit: string) => this.formatBenefit(benefit.trim()))

                .filter((benefit: string) => benefit.length > 0);

        }

        return [];

    }

    getPackageDescription(item: any): string {

        const description = item?.description || item?.short_description;

        if (typeof description === 'string' && description.trim()) {

            return description.trim();

        }

        return '';

    }

    private formatBenefit(benefit: string): string {

        const normalizedBenefit = benefit
            .replace(/&#x6D;/gi, 'm')
            .trim();

        const durationMatch = normalizedBenefit.match(/^unlimited print\s*(?:\*+\s*)?(\d+)\s*jam\s*(?:\*+)?$/i);

        if (durationMatch) {

            return `Cetak foto tanpa batas selama ${durationMatch[1]} jam.`;

        }

        const frameMatch = normalizedBenefit.match(/^(\d+)\s+custom frame pilihan$/i);

        if (frameMatch) {

            return `${frameMatch[1]} desain frame kustom.`;

        }

        const crewMatch = normalizedBenefit.match(/^(\d+)\s+crew IT support$/i);

        if (crewMatch) {

            return `${crewMatch[1]} kru teknis pendukung acara.`;

        }

        const propMatch = normalizedBenefit.match(/^(\d+)\s+properti pilihan$/i);

        if (propMatch) {

            return `${propMatch[1]} pilihan properti foto.`;

        }

        const standardBenefitLabels: Record<string, string> = {

            'real-time softfile via qr': 'File digital foto tersedia secara real-time melalui QR Code.',

            'general backdrop': 'Backdrop standar.',

            'sequin backdrop': 'Backdrop sequin.',

            'plastik frame cover': 'Pelindung frame berbahan plastik.',

            'premium frame cover': 'Pelindung frame premium.',

            'voucher (by request)': 'Voucher tersedia berdasarkan permintaan.',

            'special souvenir': 'Suvenir spesial.'

        };

        return standardBenefitLabels[normalizedBenefit.toLowerCase()] || normalizedBenefit;

    }

    /* =========================================================

       IMAGE

    ========================================================= */

    getCategoryImage(): string {

        const slug =

            (

                this.categorySlug ||

                this.categoryData?.slug ||

                this.categoryData?.name ||

                ''

            ).toLowerCase();

        if (

            slug.includes('poppy') ||

            slug.includes('popy')

        ) {

            return '/assets/visidea/foto-Poppy.png';

        }

        if (

            slug.includes(

                'vintage'

            )

        ) {

            return '/assets/visidea/vtgfix.png';

        }

        if (

            slug.includes('hyppe') ||

            slug.includes('hype')

        ) {

            return '/assets/visidea/hyppe-photobooth.JPG';

        }

        return '/assets/visidea/hyppe-photobooth.JPG';

    }

    getHeaderImage(): string {

        const slug =

            (

                this.categorySlug ||

                this.categoryData?.slug ||

                this.categoryData?.name ||

                ''

            ).toLowerCase();

        if (

            slug.includes('poppy') ||

            slug.includes('popy')

        ) {

            return '/assets/visidea/foto-Poppy.png';

        }

        if (

            slug.includes('hyppe') ||

            slug.includes('hype')

        ) {

            return '/assets/visidea/hyppe-photobooth.JPG';

        }

        return this.getCategoryImage();

    }

    getProductImage(): string {

        const slug =

            (

                this.categorySlug ||

                this.categoryData?.slug ||

                this.categoryData?.name ||

                ''

            ).toLowerCase();

        if (

            slug.includes('poppy') ||

            slug.includes('popy')

        ) {

            return '/assets/visidea/foto-Poppy.png';

        }

        if (

            slug.includes('hyppe') ||

            slug.includes('hype')

        ) {

            return '/assets/visidea/hyppe-photobooth.JPG';

        }

        return '/assets/visidea/vintage-photobooth.JPG';

    }

    getPrinterImage(): string {

        return '/assets/visidea/printer.png';

    }

    getAiImage(): string {

        return '/assets/visidea/ai.png';

    }

    getPackageImage(

        item: any,

        index: number

    ): string {

        const slug =

            (

                this.categorySlug ||

                this.categoryData?.slug ||

                this.categoryData?.name ||

                ''

            ).toLowerCase();

        if (

            slug.includes(

                'poppy'

            )

        ) {

            if (

                index === 0

            ) {

                return '/assets/visidea/photobooth/poppy-basic.png';

            }

            if (

                index === 1

            ) {

                return '/assets/visidea/photobooth/poppy-elite.png';

            }

        }

        return this.getCategoryImage();

    }

    onImageError(

        event: Event,

        fallback: string

    ): void {

        const img =

            event.target as HTMLImageElement;

        if (

            img.src.includes(

                fallback

            )

        ) {

            return;

        }

        img.src =

            fallback;

    }

    /* =========================================================

       CART

    ========================================================= */

    trackByPackage(

        index: number,

        item: any

    ): string | number {

        return (

            item.id ??

            item.name ??

            index

        );

    }

    addToCart(

        item: any

    ): void {

        this.cartService.addItem(this.createCartItem(item));

    }

    private createCartItem(item: any): Omit<CartItem, 'qty'> {

        const categoryKey =

            this.categoryData?.id ??

            this.categoryData?.slug ??

            this.categoryData?.name ??

            this.categorySlug ??

            'vintage';

        const packageKey =

            item.id ??

            item.name;

        const categoryName =

            this.categoryData?.displayName ||

            this.categoryData?.name ||

            'Photobooth';

        const cartName = item.name;

        const benefits = this.getBenefits(item);

        const description = benefits.length

            ? benefits.join('\n')

            : item.description || item.short_description || '';

        const image = this.getProductImage();

        const isUuid = this.cartService.isUuid(item.id) ? item.id : (this.cartService.isUuid(this.categoryData?.id) ? this.categoryData.id : undefined);

        return {

            id: isUuid || `photobooth-${encodeURIComponent(String(categoryKey))}-${encodeURIComponent(String(packageKey))}`,

            itemable_type: 'NonThemedProductPackage',

            itemable_id: isUuid,

            name: cartName,

            category: 'Photobooth',

            price: Number(item.price),

            image,

            description,

            selectedOption: item.name,

            custom_options: {

                category: 'Photobooth',

                cart_name: cartName,

                selected_option: item.name,

                description,

                image,

            },

        };

    }

    checkout(

        item: any

    ): void {

        void this.cartService.startDirectCheckout(this.createCartItem(item));

    }

}
